import { NON_MECHANICAL_BASE } from './_shared'

/**
 * Perfil EVACUACIÓN AÉREA (aerial_evacuation_line). No-mecánico.
 * Igual que buried: hoy usa los defaults no-mecánicos (ver nota en buried-evacuation).
 */
export default {
  ...NON_MECHANICAL_BASE,
}
